module.exports = __webpack_public_path__ + "img/c-en-01.ab88daf2.png";